module.exports = __webpack_public_path__ + "img/banner.c25bfd8d.jpg";